module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Bookmark-99f482541aecb1447480cac02913704a.svg";